var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 33,
    height: 33,
    rx: 16.5,
    fill: "white",
    stroke: "#DBDBDB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 16.5834C24.5029 17.6832 24.2459 18.7683 23.75 19.75C23.162 20.9265 22.2581 21.916 21.1395 22.6078C20.021 23.2995 18.7319 23.6662 17.4167 23.6667C16.3168 23.6696 15.2318 23.4126 14.25 22.9167L9.5 24.5L11.0833 19.75C10.5874 18.7683 10.3305 17.6832 10.3333 16.5834C10.3338 15.2682 10.7005 13.9791 11.3923 12.8605C12.084 11.7419 13.0735 10.838 14.25 10.25C15.2318 9.75413 16.3168 9.49716 17.4167 9.50002H17.8333C19.5703 9.59585 21.2109 10.329 22.4409 11.5591C23.671 12.7892 24.4042 14.4297 24.5 16.1667V16.5834Z",
    stroke: "#767676",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageBtn);
export default __webpack_public_path__ + "static/media/message-btn.fc402f19f1be343f23ba05edd80e171d.svg";
export { ForwardRef as ReactComponent };